import "./DDO.css";
import { useNavigate } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { db } from '../firebase';
import { doc, getDoc, updateDoc } from "firebase/firestore";
const DDO = () => {
  const navigate = useNavigate('')

  useEffect(() => {
    if (sessionStorage.getItem("login") !== "true") {
      navigate("/")
    }
  }, [])

  const [openPinDialog, setOpenPinDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [pin, setPin] = useState(""); // Store input value
  const handlePinInputChange = (e) => {
    setPin(e.target.value);
  };

  const handleOpenPinDialog = () => {
    setOpenPinDialog(true);
  };

  const handleClosePinDialog = () => {
    setOpenPinDialog(false);
    setPin(""); // Clear input field
  };

  const handleSuccessDialogClose = () => {
    setOpenSuccessDialog(false);
  };

  const handleUpdatePin = async () => {
    const empId = localStorage.getItem("empid");
    if (!empId) {
      alert("Employee ID not found in localStorage!");
      return;
    }

    const docRef = doc(db, "empmaster", empId);
    try {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        // Update the Firestore document with new pin
        await updateDoc(docRef, { pin: pin });
        setOpenPinDialog(false);
        setOpenSuccessDialog(true);
      } else {
        alert("User not found!");
      }
    } catch (error) {
      console.error("Error updating PIN:", error);
      alert("Failed to update PIN.");
    }
  };

  const handleLogout = (e) => {
    e.preventDefault();
    sessionStorage.setItem("login", false)
    window.location.replace("/")
  }

  const name = localStorage.getItem("empname");
  return (
    <div className="user-container">
      <Dialog open={openPinDialog} onClose={handleClosePinDialog}>
        <DialogTitle>Enter New PIN:</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="adminpin"
            label="New PIN"
            type="number"
            fullWidth
            variant="standard"
            value={pin}
            onChange={handlePinInputChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePinDialog}>Cancel</Button>
          <Button onClick={handleUpdatePin}>Update</Button>
        </DialogActions>
      </Dialog>

      {/* Success Dialog */}
      <Dialog open={openSuccessDialog} onClose={handleSuccessDialogClose}>
        <DialogTitle>PIN Updated Successfully!</DialogTitle>
        <DialogActions>
          <Button onClick={handleSuccessDialogClose}>OK</Button>
        </DialogActions>
      </Dialog>

      <h1 className="welcome">Welcome {name || "User"}</h1><br /><br />
      <div className="icon-grid">
        <div className="icon-box">
          <img src="/assets/budgetallocation.png" alt="Profile" className="icon" onClick={e => navigate('/fundallocation')} />
        </div>
        <div className="icon-box">
          <img src="/assets/pa.png" alt="Calendar" className="icon" onClick={e => navigate('/ddopending')} />
        </div>
        <div className="icon-box">
          <img src="/assets/reportdisplay.png" alt="Tasks" className="icon" onClick={e => navigate('/reportdisplay')} />
        </div>
        <div className="icon-box">
          <img src="/assets/notesheet.png" alt="Settings" className="icon" onClick={() => navigate('/notesheetdownload3')} />
        </div>
        <div className="icon-box">
          <img src="/assets/acsettlement.png" alt="Settings" className="icon" onClick={e => navigate('/settlement')} />
        </div>
        <div className="icon-box">
          <img src="/assets/PIN.png" alt="Settings" className="icon" onClick={handleOpenPinDialog} />
        </div>
      </div><br /><br />
      <center>
        <img src="/assets/logout.png" style={{ height: '120px' }} alt="" onClick={handleLogout} />
      </center>
    </div>
  );
};

export default DDO;
